//#region src/transformObject.ts
function transformObject(objectFunctions, source) {
	const _transform = (s) => Object.keys(objectFunctions).reduce((acc, key) => {
		return {
			...acc,
			[key]: objectFunctions[key](s)
		};
	}, {});
	return arguments.length === 2 && source ? _transform(source) : (_source) => _transform(_source);
}
var transformObject_default = transformObject;

//#endregion
export { transformObject_default };
//# sourceMappingURL=transformObject-BVZ3Cj-9.mjs.map